// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#doses .diff-time {
  display: flex;
  justify-content: center;
  align-items: center;
  /* width: calc(100% - 2rem); */
  width: 100%;
  font-size: .8rem;
  margin: 0.5rem 0;
  margin-inline: 1rem;
  color: var(--secondary-color);
  writing-mode: sideways-lr;
  position: relative;
  transform: translateX(-0.8rem);
  z-index: 1;
}

#doses .diff-time-value {
  display: inline-flex;
  justify-content: center;
  align-items: center;
}

#doses .diff-time-value.to-latest {
  transform: translateY(-8px);
}

#doses .diff-time-line {
  position: absolute;
  bottom: 50%;
  width: 60px;
  border-bottom: 1px solid var(--secondary-color);
  transform: rotate(90deg) translateY(-0.8rem);
  z-index: 0;
}

#doses .diff-time-line.to-latest {
  width: calc(60px - 0.3rem - 4px);
  transform: rotate(90deg) translateY(-0.8rem) translateX(-4px);
}

#doses .diff-time-blade {
  position: absolute;
  top: -3px;
  width: 8px;
  height: 6px;
  transform: rotate(90deg);
}

#doses .diff-time-blade.end {
  right: -2px;
}

#doses .diff-time-blade:before,
#doses .diff-time-blade:after {
  content: '';
  position: absolute;
  top: 0;
  width: 1px;
  height: 6px;
  background-color: var(--secondary-color);
}

#doses .diff-time-blade:before {
  left: 2px;
  transform: rotate(25deg);
}

#doses .diff-time-blade:after {
  left: 5px;
  transform: rotate(-25deg);
}
`, "",{"version":3,"sources":["webpack://./src/components/entries/TimeDiff.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,6BAA6B;EAC7B,yBAAyB;EACzB,kBAAkB;EAClB,8BAA8B;EAC9B,UAAU;AACZ;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,+CAA+C;EAC/C,4CAA4C;EAC5C,UAAU;AACZ;;AAEA;EACE,gCAAgC;EAChC,6DAA6D;AAC/D;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,wBAAwB;AAC1B;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,UAAU;EACV,WAAW;EACX,wCAAwC;AAC1C;;AAEA;EACE,SAAS;EACT,wBAAwB;AAC1B;;AAEA;EACE,SAAS;EACT,yBAAyB;AAC3B","sourcesContent":["#doses .diff-time {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  /* width: calc(100% - 2rem); */\n  width: 100%;\n  font-size: .8rem;\n  margin: 0.5rem 0;\n  margin-inline: 1rem;\n  color: var(--secondary-color);\n  writing-mode: sideways-lr;\n  position: relative;\n  transform: translateX(-0.8rem);\n  z-index: 1;\n}\n\n#doses .diff-time-value {\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n}\n\n#doses .diff-time-value.to-latest {\n  transform: translateY(-8px);\n}\n\n#doses .diff-time-line {\n  position: absolute;\n  bottom: 50%;\n  width: 60px;\n  border-bottom: 1px solid var(--secondary-color);\n  transform: rotate(90deg) translateY(-0.8rem);\n  z-index: 0;\n}\n\n#doses .diff-time-line.to-latest {\n  width: calc(60px - 0.3rem - 4px);\n  transform: rotate(90deg) translateY(-0.8rem) translateX(-4px);\n}\n\n#doses .diff-time-blade {\n  position: absolute;\n  top: -3px;\n  width: 8px;\n  height: 6px;\n  transform: rotate(90deg);\n}\n\n#doses .diff-time-blade.end {\n  right: -2px;\n}\n\n#doses .diff-time-blade:before,\n#doses .diff-time-blade:after {\n  content: '';\n  position: absolute;\n  top: 0;\n  width: 1px;\n  height: 6px;\n  background-color: var(--secondary-color);\n}\n\n#doses .diff-time-blade:before {\n  left: 2px;\n  transform: rotate(25deg);\n}\n\n#doses .diff-time-blade:after {\n  left: 5px;\n  transform: rotate(-25deg);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
